import React, { useEffect, useState } from 'react';
import { getLandingInfo } from '../../api/public';
import TrustedUs from './components/TrustedUs/TrustedUs';
import { Achivements } from './components/AchivementsOnNumbers';
import { Advantages } from './components/Advantages';
import { useTranslation } from 'react-i18next';
import SectionTitle from './components/SectionTitle/SectionTitle';
import MainLayout from './components/MainLayout';
import SectionLayout from './components/SectionLayout';
import WorkingProcess from './components/WorkingProcess/WorkingProcess';
import ReadMoreButton from './components/ReadMoreButton/ReadMoreButton';
import EmptyData from './components/EmptyData/EmptyData';
import HeroSectionEmployers from './components/HeroSectionEmployers/HeroSectionEmployers';

export const Employers = () => {
  const [landingData, setLandingData] = useState({
    partners: [],
    achievements: [],
  });
  const { t, i18n } = useTranslation();

  useEffect(() => {
    getLandingInfo()
      .then(res => {
        const data = res?.data?.data;
        setLandingData({
          partners: data?.companies,
          achievements: data?.info,
        });
      })
      .catch(err => {
        console.log(err);
      });
  }, [i18n.language]);
  const { partners, achievements } = landingData;

  return (
    <div>
      <main>
        <HeroSectionEmployers />
        {/*<HeroLayout variant="employers">*/}
        {/*  <div className="h-100 d-flex flex-column justify-content-between">*/}
        {/*    <div className={st.heroFlexContainer}>*/}
        {/*      <HeroInfo*/}
        {/*        title={t('heroDiscover')}*/}
        {/*        titleSecond={t('heroMoreThan')}*/}
        {/*        subtitle={t('heroDiscoverCandidates')}*/}
        {/*        description={t('heroEmployersDesc')}*/}
        {/*      />*/}
        {/*      <HeroIllustration type="employers" />*/}
        {/*    </div>*/}
        {/*    <CardStats />*/}
        {/*  </div>*/}
        {/*</HeroLayout>*/}
        <MainLayout>
          <SectionLayout>
            <SectionTitle titleWord={t('partners')} />
            <div className="row mt-2">
              {partners.length > 0 && (
                <>
                  <TrustedUs partners={partners} />
                  <ReadMoreButton link={'/view/comp'} textBtn={t('showAllComp')} />
                </>
              )}
              {partners.length === 0 && <EmptyData type="emptyCompanies" />}
            </div>
          </SectionLayout>

          <SectionLayout>
            <SectionTitle titleWord={t('searchingJobSeekers')} />
            <WorkingProcess type="employersLandingPage" />
          </SectionLayout>

          <SectionLayout>
            <SectionTitle titleWord={t('Achievements on numbers')} />
            <Achivements achievements={achievements} />
          </SectionLayout>
        </MainLayout>

        <MainLayout>
          <SectionTitle titleWord={t('Advantages')} />
          <Advantages />
        </MainLayout>
      </main>
    </div>
  );
};
